import React from "react";
import { useTranslation } from "react-i18next";

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.07 1.57-.51 1.82-.57.25-.06.52-.09.79-.09.4 0 .78.08 1.13.23l3.42 1.42c.64.27 1.08.93 1.08 1.69 0 3.87-3.13 7-7 7-7.73 0-14-6.27-14-14 0-3.87 3.13-7 7-7 .76 0 1.42.44 1.69 1.08l1.42 3.42c.15.35.23.73.23 1.13 0 .27-.03.54-.09.79-.06.25-.5 1.55-.57 1.82l-2.2 2.2z" />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
    </svg>
  );
}

export default function Contact() {
  const { t } = useTranslation();

  const phone = t("contact.phone");
  const emailAddress = t("contact.emailAddress");
  const telHref = `tel:${phone.replace(/\s/g, "")}`;

  return (
    <section id="contact" className="section section-alt">
      <div className="container">
        <div className="contact-block">
          <div className="contact-block-head">
            <h2>{t("contact.sectionTitle")}</h2>
            <p className="section-subtitle">{t("contact.sectionSubtitle")}</p>
          </div>

          <div className="contact-direct">
            <a href={telHref} className="contact-direct-card">
              <span className="contact-direct-icon">
                <PhoneIcon />
              </span>
              <span>{phone}</span>
            </a>
            <a href={`mailto:${emailAddress}`} className="contact-direct-card">
              <span className="contact-direct-icon">
                <MailIcon />
              </span>
              <span>{emailAddress}</span>
            </a>
          </div>
        </div>

        {/* Forma: odkomentiraj i dodaj useState/handleSubmit kad bude backend
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="field">
            <label>{t("contact.name")}</label>
            <input type="text" required />
          </div>
          <div className="field">
            <label>{t("contact.email")}</label>
            <input type="email" required />
          </div>
          <div className="field">
            <label>{t("contact.destination")}</label>
            <input type="text" />
          </div>
          <div className="field-row">
            <div className="field">
              <label>{t("contact.month")}</label>
              <input type="month" />
            </div>
            <div className="field">
              <label>{t("contact.people")}</label>
              <input type="number" min="1" max="20" />
            </div>
          </div>
          <div className="field">
            <label>{t("contact.message")}</label>
            <textarea rows="4" />
          </div>
          <button className="btn primary" type="submit">
            {t("contact.btnSend")}
          </button>
        </form>
        */}
      </div>
    </section>
  );
}
